// Types de prestation disponibles
export const PRESTATION_TYPES = [
  {
    value: 'prestation',
    label: 'Prestation',
    description: 'Prestation avec participants',
    icon: 'P'
  },
  {
    value: 'blocked',
    label: 'Blocage',
    description: 'Prestation en attente de confirmation',
    icon: 'B'
  },
  {
    value: 'note',
    label: 'Note',
    description: 'Information ou maintenance',
    icon: 'N'
  }
];

// Alias pour compatibilite (a supprimer progressivement)
export const SESSION_TYPES = PRESTATION_TYPES;

// Types d'hébergement
export const ACCOMMODATION_TYPES = {
  NONE: 'none',
  ALL_NIGHTS: 'all_nights',
  EXCEPT_LAST_NIGHT: 'except_last_night'
};

// Actions de résolution de conflits
export const CONFLICT_RESOLUTION_ACTIONS = {
  FORCE: 'force',
  REPLACE: 'replace',
  RESCHEDULE: 'reschedule',
  CANCEL: 'cancel',
  KEEP_AND_REPLACE: 'keep_and_replace',
  REMOVE_FROM_OTHER: 'remove_from_other'
};

// Types de conflits
export const CONFLICT_TYPES = {
  GROUP: 'group',
  TEAM_LEADER: 'team_leader',
  PARTICIPANT: 'participant',
  HOLIDAY: 'holiday',
  // Alias pour compatibilite
  ROOM: 'group',
  TRAINER: 'team_leader'
};

// Valeurs par defaut pour les heures
export const DEFAULT_HOURS = {
  PRODUCTION: 7,
  TRAVEL: 1,
  MIN_HOURS: 0,
  MAX_HOURS: 24,
  STEP: 0.5,
  // Alias pour compatibilite
  TRAINING: 7
};

// ✅ NOUVEAUX : Constants pour les modes d'affichage
export const VIEW_MODES = {
  PARTICIPANTS: 'participants',
  ADD: 'add'
};

// ✅ NOUVEAUX : Constants pour les types de jour
export const DAY_TYPES = {
  WEEKDAY: 'weekday',
  WEEKEND: 'weekend',
  HOLIDAY: 'holiday'
};

// ✅ NOUVEAUX : Constants pour les timers de debounce
export const DEBOUNCE_DELAYS = {
  SEARCH: 300,
  AVAILABILITY_CHECK: 800,
  CONFLICT_CHECK: 1200,
  RECHECK_AFTER_RESOLVE: 500
};

// ✅ NOUVEAUX : Constants pour les messages UI
export const UI_MESSAGES = {
  LOADING_AVAILABILITY: '⏳ Vérification de la disponibilité des participants...',
  CHECKING_CONFLICTS: '🔍 Vérification des conflits en cours...',
  NO_PARTICIPANTS: 'Aucun participant sélectionné',
  NO_RESULTS: 'Aucun participant trouvé',
  PARTICIPANTS_ADDED: 'participants ajoutés',
  CONFLICTS_RESOLVED: 'Conflits résolus',
  DAY_ADDED: 'Jour ajouté avec succès',
  HOURS_UPDATED: 'Heures mises à jour'
};

// Pagination
export const PAGINATION = {
  PARTICIPANTS_PER_PAGE: 20,
  DEFAULT_PAGE: 0
};

export const PARTICIPANTS_PER_PAGE = 20;

// Patterns de validation
export const VALIDATION_PATTERNS = {
  PARTICIPANT_SEARCH: /^[a-zA-ZÀ-ÿ\s\-']{0,50}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^(\+33|0)[1-9](\d{8})$/,
  TIME: /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
};

// ✅ NOUVEAUX : Constants pour les formats de date
export const DATE_FORMATS = {
  DISPLAY: 'dd/MM/yyyy',
  API: 'yyyy-MM-dd',
  FULL: 'dd/MM/yyyy HH:mm',
  TIME: 'HH:mm'
};

// ✅ NOUVEAUX : Constants pour les couleurs du thème
export const THEME_COLORS = {
  PRIMARY: '#667eea',
  SECONDARY: '#764ba2',
  SUCCESS: '#28a745',
  WARNING: '#ffc107',
  DANGER: '#dc3545',
  INFO: '#17a2b8',
  LIGHT: '#f8f9fa',
  DARK: '#343a40'
};

// ✅ NOUVEAUX : Constants pour les animations et transitions
export const ANIMATIONS = {
  FAST: '0.15s',
  NORMAL: '0.2s',
  SLOW: '0.3s',
  EXTRA_SLOW: '0.5s'
};

// ✅ NOUVEAUX : Constants pour les z-index
export const Z_INDEX = {
  DROPDOWN: 1000,
  MODAL: 2000,
  TOOLTIP: 3000,
  NOTIFICATION: 4000
};

export const getStatusInfo = (status) => {
  return AVAILABILITY_STATUS_INFO[status] || {
    label: 'Statut inconnu',
    color: '#6c757d',
    icon: '❓'
  };
};

export const getConflictActionMessage = (action) => {
  return CONFLICT_RESOLUTION_MESSAGES[action] || 'Action inconnue';
};

export const isWeekday = (date) => {
  const day = new Date(date).getDay();
  return day >= 1 && day <= 5; // Lundi à Vendredi
};

export const isWeekend = (date) => {
  const day = new Date(date).getDay();
  return day === 0 || day === 6; // Dimanche ou Samedi
};

// Messages de validation
export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'Ce champ est obligatoire',
  INVALID_EMAIL: 'Adresse email invalide',
  INVALID_PHONE: 'Numero de telephone invalide',
  INVALID_TIME: 'Format d\'heure invalide (HH:MM)',
  INVALID_DATE: 'Date invalide',
  START_DATE_AFTER_END: 'La date de debut doit etre anterieure a la date de fin',
  PARTICIPANTS_REQUIRED: 'Au moins un participant est requis pour une prestation',
  TEAM_LEADER_REQUIRED: 'Un chef d\'equipe est requis pour une prestation',
  GROUP_REQUIRED: 'Un groupe est requis',
  CLIENT_REQUIRED: 'Un client est requis pour une prestation',
  BLOCK_REASON_REQUIRED: 'Une raison de blocage est requise',
  MAINTENANCE_DESCRIPTION_REQUIRED: 'Une description de maintenance est requise',
  // Alias pour compatibilite
  TRAINER_REQUIRED: 'Un chef d\'equipe est requis pour une prestation',
  ROOM_REQUIRED: 'Un groupe est requis'
};

// Délais pour les interactions UI
export const UI_DELAYS = {
  DEBOUNCE_INPUT: 300,
  DEBOUNCE_SEARCH: 500,
  DEBOUNCE_CONFLICT_CHECK: 1000,
  NOTIFICATION_DURATION: 3000,
  SUCCESS_DURATION: 2000,
  ERROR_DURATION: 5000
};

// Couleurs des statuts de prestation (progression : Orange → Jaune → Vert → Bleu)
export const SESSION_STATUS_COLORS = {
  RESERVED: '#FFA500',  // Orange - Réservée
  VALIDATED: '#FFD966', // Jaune pastel - Validée
  PREPARED: '#008000',  // Vert - Préparée
  INVOICED: '#0000FF'   // Bleu - Facturée
};

// Configuration responsive
export const RESPONSIVE_BREAKPOINTS = {
  MOBILE_SMALL: 480,
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1200
};

export const PARTICIPANT_STATUS = {
  AVAILABLE: 'available',
  HR_UNAVAILABLE: 'hr_unavailable',
  HR_TRAINING: 'hr_training',
  TRAINING_CONFLICT: 'training_conflict',
  CONFLICTED: 'conflicted',
  HOLIDAY: 'holiday',
  LEAVE: 'leave',
  TRAINING: 'training'
};

export const AVAILABILITY_STATUS_INFO = {
  [PARTICIPANT_STATUS.AVAILABLE]: { 
    label: 'Disponible', 
    color: '#28a745', 
    icon: '✅' 
  },
  [PARTICIPANT_STATUS.HR_UNAVAILABLE]: { 
    label: 'Indisponible RH', 
    color: '#dc3545', 
    icon: '🚫' 
  },
  [PARTICIPANT_STATUS.HR_TRAINING]: { 
    label: 'Formation RH', 
    color: '#fd7e14', 
    icon: '📋' 
  },
  [PARTICIPANT_STATUS.TRAINING_CONFLICT]: { 
    label: 'En formation', 
    color: '#ffc107', 
    icon: '📚' 
  },
  [PARTICIPANT_STATUS.CONFLICTED]: { 
    label: 'En conflit', 
    color: '#dc3545', 
    icon: '⚠️' 
  },
  [PARTICIPANT_STATUS.HOLIDAY]: { 
    label: 'Jour férié', 
    color: '#ffc107', 
    icon: '🏖️' 
  },
  [PARTICIPANT_STATUS.LEAVE]: { 
    label: 'Congé/RTT', 
    color: '#17a2b8', 
    icon: '🏝️' 
  },
  [PARTICIPANT_STATUS.TRAINING]: { 
    label: 'En formation', 
    color: '#fd7e14', 
    icon: '📚' 
  }
};

// ✅ NOUVEAUX : Constants pour les conflits
export const CONFLICT_ACTIONS = {
  REMOVE_FROM_OTHER: 'remove_from_other',
  KEEP_AND_REPLACE: 'keep_and_replace',
  REMOVE: 'remove',
  REPLACE_HERE: 'replace_here',
  FORCE: 'force'
};

export const CONFLICT_RESOLUTION_MESSAGES = {
  [CONFLICT_ACTIONS.REMOVE_FROM_OTHER]: 'Participant retiré des autres formations',
  [CONFLICT_ACTIONS.KEEP_AND_REPLACE]: 'Participant gardé ici, remplacé ailleurs',
  [CONFLICT_ACTIONS.REMOVE]: 'Participant retiré de cette formation',
  [CONFLICT_ACTIONS.REPLACE_HERE]: 'Participant remplacé dans cette formation',
  [CONFLICT_ACTIONS.FORCE]: 'Conflit ignoré, participant maintenu'
};

// Styles réutilisables
export const COMMON_STYLES = {
  // === INPUTS ===
  INPUT: {
    width: '100%',
    padding: 'clamp(10px, 2.5vw, 14px)',
    border: '2px solid #e1e5e9',
    borderRadius: '10px',
    fontSize: 'clamp(14px, 2.5vw, 16px)',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    transition: 'all 0.2s ease',
    outline: 'none',
    minHeight: '44px'
  },

  TEXTAREA: {
    width: '100%',
    padding: '12px',
    border: '2px solid #e1e5e9',
    borderRadius: '10px',
    fontSize: '14px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    resize: 'vertical',
    minHeight: '80px'
  },

  // === BUTTONS ===
  BUTTON: {
    padding: 'clamp(10px, 2.5vw, 14px) clamp(16px, 4vw, 24px)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    fontSize: 'clamp(13px, 2.5vw, 15px)',
    fontWeight: '600',
    transition: 'all 0.2s ease',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },

  BUTTON_PRIMARY: {
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    minHeight: '44px'
  },

  BUTTON_SECONDARY: {
    background: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    minHeight: '44px'
  },

  BUTTON_DANGER: {
    background: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    minHeight: '44px'
  },

  // === LABELS & TYPOGRAPHY ===
  LABEL: {
    display: 'block',
    marginBottom: '6px',
    fontWeight: '600',
    color: '#495057',
    fontSize: 'clamp(13px, 2.5vw, 15px)'
  },

  SECTION_TITLE: {
    margin: '0 0 16px 0',
    fontSize: 'clamp(16px, 3vw, 18px)',
    fontWeight: '600',
    color: '#495057',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingBottom: '8px',
    borderBottom: '2px solid #e9ecef'
  },

  PAGE_TITLE: {
    margin: '0 0 24px 0',
    fontSize: '24px',
    fontWeight: '700',
    color: '#2c3e50'
  },

  // === FLEX LAYOUTS ===
  FLEX_ROW: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },

  FLEX_ROW_BETWEEN: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  FLEX_ROW_CENTER: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },

  FLEX_ROW_END: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '12px'
  },

  FLEX_COLUMN: {
    display: 'flex',
    flexDirection: 'column'
  },

  FLEX_COLUMN_CENTER: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },

  FLEX_WRAP: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px'
  },

  // === CARDS & CONTAINERS ===
  CARD: {
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    padding: '20px'
  },

  CARD_HEADER: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    paddingBottom: '12px',
    borderBottom: '1px solid #e9ecef'
  },

  MODAL_OVERLAY: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000
  },

  MODAL_CONTENT: {
    background: 'white',
    borderRadius: '16px',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
  },

  FORM_GROUP: {
    marginBottom: '16px'
  },

  FORM_ROW: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    marginBottom: '16px'
  },

  // === TABLES ===
  TABLE: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px'
  },

  TABLE_HEADER: {
    background: '#f8f9fa',
    fontWeight: '600',
    textAlign: 'left',
    padding: '12px',
    borderBottom: '2px solid #dee2e6'
  },

  TABLE_CELL: {
    padding: '12px',
    borderBottom: '1px solid #e9ecef',
    verticalAlign: 'middle'
  },

  TABLE_ROW_HOVER: {
    cursor: 'pointer',
    transition: 'background 0.15s ease'
  },

  // === STATUS BADGES ===
  BADGE: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '600'
  },

  BADGE_SUCCESS: {
    background: '#d4edda',
    color: '#155724'
  },

  BADGE_WARNING: {
    background: '#fff3cd',
    color: '#856404'
  },

  BADGE_DANGER: {
    background: '#f8d7da',
    color: '#721c24'
  },

  BADGE_INFO: {
    background: '#d1ecf1',
    color: '#0c5460'
  },

  // === EMPTY STATES ===
  EMPTY_STATE: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#6c757d'
  },

  EMPTY_STATE_ICON: {
    fontSize: '48px',
    marginBottom: '16px',
    opacity: 0.5
  },

  // === LOADING ===
  LOADING_CONTAINER: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    color: '#6c757d'
  },

  SPINNER: {
    width: '24px',
    height: '24px',
    border: '3px solid #e9ecef',
    borderTopColor: '#667eea',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },

  // === ICONS ===
  ICON_BUTTON: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.15s ease'
  },

  // === TOOLTIPS ===
  TOOLTIP: {
    position: 'absolute',
    background: '#333',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '6px',
    fontSize: '12px',
    zIndex: 3000,
    whiteSpace: 'nowrap'
  },

  // === ALERTS ===
  ALERT: {
    padding: '12px 16px',
    borderRadius: '10px',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },

  ALERT_SUCCESS: {
    background: '#d4edda',
    color: '#155724',
    border: '1px solid #c3e6cb'
  },

  ALERT_WARNING: {
    background: '#fff3cd',
    color: '#856404',
    border: '1px solid #ffeeba'
  },

  ALERT_DANGER: {
    background: '#f8d7da',
    color: '#721c24',
    border: '1px solid #f5c6cb'
  },

  ALERT_INFO: {
    background: '#d1ecf1',
    color: '#0c5460',
    border: '1px solid #bee5eb'
  },

  // === PROGRESS BAR ===
  PROGRESS_CONTAINER: {
    background: '#e9ecef',
    borderRadius: '10px',
    height: '24px',
    overflow: 'hidden',
    margin: '0 auto 15px',
    maxWidth: '400px'
  },

  PROGRESS_BAR: {
    background: 'linear-gradient(90deg, #007bff, #0056b3)',
    height: '100%',
    transition: 'width 0.3s ease',
    borderRadius: '10px'
  },

  // === STAT CARDS ===
  STAT_CARD: {
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  },

  STAT_VALUE: {
    fontSize: '28px',
    fontWeight: '700'
  },

  STAT_LABEL: {
    fontSize: '13px'
  },

  // === CLOSE BUTTON ===
  CLOSE_BUTTON: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#666',
    padding: '4px',
    lineHeight: 1
  },

  // === STEP INDICATOR ===
  STEP_CIRCLE: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '14px'
  },

  STEP_LABEL: {
    fontSize: '12px',
    marginTop: '5px'
  },

  // === GRIDS ===
  GRID_3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '15px'
  },

  GRID_4: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '10px'
  }
};

// Configuration API
export const API_ENDPOINTS = {
  // Nouveaux endpoints
  PRESTATIONS: '/api/prestations',
  GROUPS: '/api/groups',
  CLIENTS: '/api/clients',
  USERS: '/api/users',
  PRESTATION_STATUSES: '/api/prestations/statuses',
  CHECK_CONFLICTS: '/api/prestations/check-participant-conflicts',
  RESOLVE_CONFLICTS: '/api/prestations/resolve-conflicts',
  GROUP_AVAILABILITY: '/api/groups/availability',
  USER_AVAILABILITY: '/api/users/availability',
  FIND_REPLACEMENTS: '/api/prestations/find-replacements',
  HOLIDAYS: '/api/holidays'
};

export default {
  PRESTATION_TYPES,
  SESSION_TYPES,
  ACCOMMODATION_TYPES,
  AVAILABILITY_STATUS_INFO,
  CONFLICT_RESOLUTION_ACTIONS,
  CONFLICT_TYPES,
  DEFAULT_HOURS,
  PAGINATION,
  VALIDATION_PATTERNS,
  VALIDATION_MESSAGES,
  UI_DELAYS,
  SESSION_STATUS_COLORS,
  RESPONSIVE_BREAKPOINTS,
  COMMON_STYLES,
  API_ENDPOINTS
};